
import { defineComponent } from "vue";
import { Saih } from "@/types/saih.type";
import { Filter } from "@/types/filter.type";
import { getSaih } from "@/service/saih.service";
import { dateFormatDate } from "@/utils/date.utils";

export default defineComponent({
  components: {},
  props: {},
  data() {
    return {
      items: [] as Saih[],
      query: "" as string,
      currentPage: 1 as number,
      hasMore: true,
    };
  },
  mounted() {
    this.currentPage = 1;
    this.refreshItems();
  },
  methods: {
    dateFormatDate,
    async showMore() {
      const filter: Filter = {};
      this.hasMore = false;
      const rowPerPage = 10;
      if (this.query) {
        filter.multi = this.query;
      }

      const { data, totalRows } = await getSaih(this.currentPage, rowPerPage, filter);

      // - concat result array
      this.items = [...this.items, ...data];

      // - check if exist more result
      this.hasMore = totalRows > this.currentPage * rowPerPage;
      this.currentPage++;
    },

    async refreshItems(item: Saih | undefined = undefined) {
      let index = -1;
      if (this.items && item) {
        index = this.items.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.items[index] = item;
      } else {
        this.items = [];
        this.currentPage = 1;
        await this.showMore();
      }
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMagnitude(info: any) {
      const jsonSaih = JSON.parse(info);
      return [jsonSaih.magnitude, jsonSaih.value, jsonSaih.unit];
    },
  },
});
